__turbopack_context__.v({
  "block-btn": "PhoneDashboard-module-scss-module__yA93wq__block-btn",
  "block-state": "PhoneDashboard-module-scss-module__yA93wq__block-state",
  "caller-sms-logs-back-btn": "PhoneDashboard-module-scss-module__yA93wq__caller-sms-logs-back-btn",
  "caller-sms-logs-title": "PhoneDashboard-module-scss-module__yA93wq__caller-sms-logs-title",
  "caller-sms-senders-table": "PhoneDashboard-module-scss-module__yA93wq__caller-sms-senders-table",
  "content-wrapper": "PhoneDashboard-module-scss-module__yA93wq__content-wrapper",
  "copied-confirmation": "PhoneDashboard-module-scss-module__yA93wq__copied-confirmation",
  "copy-button": "PhoneDashboard-module-scss-module__yA93wq__copy-button",
  "copy-button-wrapper": "PhoneDashboard-module-scss-module__yA93wq__copy-button-wrapper",
  "copy-controls": "PhoneDashboard-module-scss-module__yA93wq__copy-controls",
  "copy-icon": "PhoneDashboard-module-scss-module__yA93wq__copy-icon",
  "dashboard-card": "PhoneDashboard-module-scss-module__yA93wq__dashboard-card",
  "dashboard-card-caller-sms-senders-header": "PhoneDashboard-module-scss-module__yA93wq__dashboard-card-caller-sms-senders-header",
  "dashboard-card-header": "PhoneDashboard-module-scss-module__yA93wq__dashboard-card-header",
  "date-created": "PhoneDashboard-module-scss-module__yA93wq__date-created",
  "forward-state": "PhoneDashboard-module-scss-module__yA93wq__forward-state",
  "forward-target": "PhoneDashboard-module-scss-module__yA93wq__forward-target",
  "forwarded-type-icon": "PhoneDashboard-module-scss-module__yA93wq__forwarded-type-icon",
  "forwarding-toggle": "PhoneDashboard-module-scss-module__yA93wq__forwarding-toggle",
  "forwarding-toggle-state": "PhoneDashboard-module-scss-module__yA93wq__forwarding-toggle-state",
  "greyed-contact": "PhoneDashboard-module-scss-module__yA93wq__greyed-contact",
  "header-phone-number": "PhoneDashboard-module-scss-module__yA93wq__header-phone-number",
  "inactive-statistics": "PhoneDashboard-module-scss-module__yA93wq__inactive-statistics",
  "is-shown": "PhoneDashboard-module-scss-module__yA93wq__is-shown",
  "main-phone-wrapper": "PhoneDashboard-module-scss-module__yA93wq__main-phone-wrapper",
  "metadata": "PhoneDashboard-module-scss-module__yA93wq__metadata",
  "metadata-container": "PhoneDashboard-module-scss-module__yA93wq__metadata-container",
  "nav-icon": "PhoneDashboard-module-scss-module__yA93wq__nav-icon",
  "phone-controls": "PhoneDashboard-module-scss-module__yA93wq__phone-controls",
  "phone-controls-container": "PhoneDashboard-module-scss-module__yA93wq__phone-controls-container",
  "phone-statistics": "PhoneDashboard-module-scss-module__yA93wq__phone-statistics",
  "phone-statistics-body": "PhoneDashboard-module-scss-module__yA93wq__phone-statistics-body",
  "phone-statistics-container": "PhoneDashboard-module-scss-module__yA93wq__phone-statistics-container",
  "phone-statistics-title": "PhoneDashboard-module-scss-module__yA93wq__phone-statistics-title",
  "sender-controls": "PhoneDashboard-module-scss-module__yA93wq__sender-controls",
  "sender-date": "PhoneDashboard-module-scss-module__yA93wq__sender-date",
  "sender-date-wrapper": "PhoneDashboard-module-scss-module__yA93wq__sender-date-wrapper",
  "sender-number": "PhoneDashboard-module-scss-module__yA93wq__sender-number",
  "senders-cta": "PhoneDashboard-module-scss-module__yA93wq__senders-cta",
  "senders-panel": "PhoneDashboard-module-scss-module__yA93wq__senders-panel",
  "senders-panel-body": "PhoneDashboard-module-scss-module__yA93wq__senders-panel-body",
  "unblocked": "PhoneDashboard-module-scss-module__yA93wq__unblocked",
  "update-settings-cta": "PhoneDashboard-module-scss-module__yA93wq__update-settings-cta",
  "warning-icon": "PhoneDashboard-module-scss-module__yA93wq__warning-icon",
});
